export var colors = {
    // Grey
    G000: '#ffffff',
    G000_ALPHA_30: 'rgba(255,255,255,0.3)',
    G100: '#f6f6f6',
    G200: '#eeeeee',
    G250: '#dfdfdf',
    G300: '#c0c0c0',
    G350: '#a0a0a0',
    G400: '#888888',
    G500: '#656565',
    G600: '#444444',
    G700: '#383838',
    G800: '#2d2d2d',
    G900: '#222222',
    G900_ALPHA_30: 'rgba(34,34,34,0.3)',
    // Blue
    B50: '#daeefe',
    B100: '#b8e0ff',
    B150: '#96d5f1',
    B250: '#50c2ee',
    B400: '#1a8dc2',
    B500: '#007db6',
    B600: '#006999',
    B700: '#004e73',
    // Cobalt
    Cob200: '#92bad9',
    Cob400: '#026ab3',
    Cob500: '#0d61a1',
    Cob600: '#0b5994',
    Cob650: '#054d82',
    Cob700: '#084776',
    // Teal
    T50: '#e0f2f1',
    T100: '#cfe9e8',
    T200: '#b2dfdb',
    T300: '#6bd8ca',
    T500: '#009688',
    T600: '#00897b',
    T700: '#00796b',
    // Green
    Grn50: '#e8ffe5',
    Grn100: '#c2f8bb',
    Grn200: '#9deb93',
    Grn300: '#89c95a',
    Grn400: '#54b948',
    Grn500: '#45a33a',
    Grn600: '#3b8f31',
    Grn700: '#337e2a',
    // Malachite
    Ml100: '#dff2ea',
    Ml200: '#c1e7d7',
    Ml400: '#02886C',
    Ml500: '#005f4b',
    Ml700: '#004c3c',
    // Beige
    Bg50: '#f8f8f4',
    Bg100: '#f1f1e8',
    Bg200: '#deded6',
    Bg300: '#e0dacd',
    Bg350: '#d1ccc1',
    Bg400: '#c7c0b2',
    Bg500: '#b7b7a9',
    Bg600: '#828275',
    Bg700: '#716d65',
    Bg800: '#615d56',
    // Yellow
    Y50: '#fffbdb',
    Y100: '#fff8c4',
    Y200: '#fdea9e',
    Y400: '#f9da70',
    Y450: '#f2c973',
    Y500: '#f5c710',
    Y600: '#e29c06',
    Y700: '#bf710c',
    Y800: '#a55d00',
    // Red
    R50: '#ffe3e3',
    R150: '#faafaf',
    R300: '#f68384',
    R500: '#ed796a',
    R800: '#e8595a',
    R900: '#d44142',
    R950: '#e30613',
    R970: '#c10510',
    R980: '#9f040d',
    // Dark Overlay
    G200DarkOver15: '#CBCBCB',
    B100DarkOver15: '#9DBFD9',
    Y200DarkOver15: '#D7C787',
    T200DarkOver15: '#98BEBA',
    Grn100DarkOver15: '#A5D39F',
    Ml200DarkOver15: '#A4C5B7'
};
//# sourceMappingURL=colors.js.map